import React, { ReactNode } from 'react'
import { colors, HeartIcon, StarIcon, ThumbsupIcon } from '@diversioteam/diversio-ds'

import { PulseSurveyDisplaySubType } from 'api/actions/pulseSurveys/pulseSurveysActions.types'

import { RatingListProps } from './ratingList.types'
import * as S from './ratingList.styles'

export const ratingMap: Record<PulseSurveyDisplaySubType, ReactNode> = {
    star: <StarIcon type="line" color={colors.secondary300} />,
    heart: <HeartIcon type="line" color={colors.secondary300} />,
    thumb: <ThumbsupIcon type="line" color={colors.secondary300} />,
}

export const RatingList = ({ item }: RatingListProps) => {
    return (
        <S.RatingListWrapper>
            {Array.from({ length: item.ratingWeight }).map((_, index) => (
                <S.RatingListItem key={index}>
                    <S.RatingListItemIndex>{index + 1}</S.RatingListItemIndex>

                    {ratingMap[item.ratingType]}
                </S.RatingListItem>
            ))}
        </S.RatingListWrapper>
    )
}
